import { render, staticRenderFns } from "./OrderRoomType.vue?vue&type=template&id=2bd9f156&scoped=true"
import script from "./OrderRoomType.vue?vue&type=script&lang=js"
export * from "./OrderRoomType.vue?vue&type=script&lang=js"
import style0 from "./OrderRoomType.vue?vue&type=style&index=0&id=2bd9f156&prod&lang=scss&scoped=true"
import style1 from "./OrderRoomType.vue?vue&type=style&index=1&id=2bd9f156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9f156",
  null
  
)

export default component.exports